import {MatDialogConfig} from '@angular/material/dialog';
import {ToothConfigurationModel} from '../../../models/teeth/tooth-configuration.model';

export class ToothPickerConfigModel extends MatDialogConfig {
  isMultiSelect = true;
  selectedTeeth: ToothConfigurationModel[] = [];

  caseWorkItemId: string;
  caseWorkItemFormId: string;
}
